import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";

/**
 * `/lab/producao?responsavel=<userId>` deixa o quadro filtrado nos serviços daquele colaborador.
 *
 * Existe pra "Ver produção" dos cartões da Equipe ter um destino de verdade — sem isso o botão
 * abriria a produção inteira e a pessoa teria que caçar os trabalhos do colega na mão. É o mesmo
 * recorte que o "Meus trabalhos" já faz (`assignedToUserId`), só que apontando pra outra pessoa.
 */
export function useResponsavelPorUrl(): {
  responsavelId: string | null;
  limpar: () => void;
} {
  const location = useLocation();
  const navigate = useNavigate();
  const daUrl = new URLSearchParams(location.search).get("responsavel");
  const [responsavelId, setResponsavelId] = useState<string | null>(daUrl);
  const jaAplicou = useRef<string | null>(null);

  useEffect(() => {
    if (!daUrl || jaAplicou.current === daUrl) return;
    jaAplicou.current = daUrl;
    setResponsavelId(daUrl);
    // Tira o parâmetro da URL: o filtro vira estado da tela, e um F5 não o reimpõe depois de o
    // usuário ter limpado.
    navigate(location.pathname, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [daUrl]);

  return { responsavelId, limpar: () => setResponsavelId(null) };
}
